import React, { useState } from 'react';
import DailyTransactionForm from './DailyTransactionForm';
import TransactionView from './TransactionView';
import styles from './Transaction.module.css';

const Transaction = () => {
  const [activeView, setActiveView] = useState('add');

  return (
    <div className={styles.container}>
      <div className={styles.tabBar}>
        <div className={styles.segment}>
          <button
            className={`${styles.tab} ${activeView === 'add' ? styles.active : ''}`}
            onClick={() => setActiveView('add')}
          >
            Add Transaction
          </button>
          <button
            className={`${styles.tab} ${activeView === 'view' ? styles.active : ''}`}
            onClick={() => setActiveView('view')}
          >
            View Transactions
          </button>
        </div>
      </div>

      <div className={styles.viewContainer}>
        {activeView === 'add' ? <DailyTransactionForm /> : <TransactionView />}
      </div>
    </div>
  );
};

export default Transaction;